import React, {
    CompositionEventHandler,
    useContext,
    useEffect,
    useRef,
} from 'react';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addChat } from '../redux/state/chat';
import format from 'date-fns/format';
import { useSocket } from '../hook/useSocket';
import {
    ChatInterface,
    DialogInterface,
    JsFuntionInterface,
    ReduxFunctionInterface,
    SendMessageEventInterface,
} from '../utils/interfaces';
import Button from '../component/Button';
import { useCacheService } from '../hook/useCacheService';
import classNames from 'classnames';
import { filter } from '../utils/chatFilter';
import { useTranslation } from 'react-i18next';
import { addDialog, removeDialog } from '../redux/state/dialog';
import { editSession, editSessions } from '../redux/state/session';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark, faStar, faPaperclip, faTimes } from '@fortawesome/free-solid-svg-icons';
import { editStatus } from '../redux/state/status';
import Swal from 'sweetalert2';
import { getOS } from '../utils/navigator';
import IntentSuggestionModal from '../element/Modal/IntentSuggestionModal';
import e from 'express';
import { post } from '../utils/rest';
import { error } from '../utils/console';
import { checkInputMessage } from '../helper/common';
import TypingMessage from './TypingMessage';
import { parseGIF, decompressFrames } from 'gifuct-js';
import { getBrowser, getPlatform } from '../utils/salesforceVisitorDetails';
import { compressImageFile } from '../utils/compressImage';
import { store } from '../redux/store'; 

interface Props {
    debug?: string;
}

interface SelectedImage {
    id: string;
    file: File;
    preview: string;
    name: string;
}

const Footer = (props: Props) => {
    const [inputMessage, setInputMessage] = useState<string>('');

    const [filteredMessage, setFilteredMessage] = useState<string>('');

    const [messageToSend, setMessageToSend] = useState<string>('');

    const [isTyping, setIsTyping] = useState<boolean>(false);

    const [typingTimer, setTypingTimer] = useState<any>(null);

    const [isValidInputMessage, setIsValidInputMessage] = useState(false);

    const [selectedImages, setSelectedImages] = useState<SelectedImage[]>([]);

    const { t } = useTranslation();

    const inputRef = useRef<HTMLInputElement | null>(null);
    const sendingRef = useRef(false);

    const socket = useSocket();

    const dispatch = useDispatch();
    const cacheService = useCacheService();

    const isChatAlive = useSelector(
        (state: { status: { isChatAlive: Boolean } }) =>
            state.status.isChatAlive
    );

    const chatId = useSelector(
        (state: { session: { chatId: string } }) => state.session.chatId
    );

    const botId = useSelector(
        (state: { session: { botId: string } }) => state.session.botId
    );

    const acctId = useSelector(
        (state: { session: { acctId: string } }) => state.session.acctId
    );

    const username = useSelector(
        (state: { session: { username: string } }) => state.session.username
    );

    const sessionId = useSelector(
        (state: { session: { sessionId: string } }) => state.session.sessionId
    );

    const tabId = useSelector(
        (state: { session: { tabId: string } }) => state.session.tabId
    );

    const laAffinityToken = useSelector(
        (state: { session: { laAffinityToken: string } }) =>
            state.session.laAffinityToken
    );

    const laSessionKey = useSelector(
        (state: { session: { laSessionKey: string } }) =>
            state.session.laSessionKey
    );

    const chatMode = useSelector(
        (state: { session: { chatMode: string } }) => state.session.chatMode
    );

    const filterStrings = useSelector(
        (state: { chatFilter: { filterStrings: string } }) =>
            state.chatFilter.filterStrings
    );

    const filters = useSelector(
        (state: { chatFilter: { filters: object } }) => state.chatFilter.filters
    );

    const regExp =
        filterStrings.length > 0
            ? new RegExp((filterStrings.normalize("NFC")).slice(1), 'g')
            : null;

    const typingBarPlaceHolder = useSelector(
        (state: { systemMessages: { typing_bar: { message: string } } }) =>
            state.systemMessages.typing_bar.message
    );

    const isChatRatingSubmitted = useSelector(
        (state: { settings: { isChatRatingSubmitted: boolean } }) =>
            state.settings.isChatRatingSubmitted
    );

    const botCloseButtonColor = useSelector(
        (state: { settings: { botCloseButtonColor: string } }) =>
            state.settings.botCloseButtonColor
    );

    const botCloseButtonText = useSelector(
        (state: { settings: { botCloseButtonText: string } }) =>
            state.settings.botCloseButtonText
    );

    const botColor = useSelector(
        (state: { settings: { botColor: string } }) => state.settings.botColor
    );

    const chatRatingDone = useSelector(
        (state: { session: { chatRatingDone: boolean } }) =>
            state.session.chatRatingDone
    );

    const botButtonColor = useSelector(
        (state: { settings: { botButtonColor: string } }) =>
            state.settings.botButtonColor
    );

    const botChatBgColor = useSelector(
        (state: { settings: { botChatBgColor: string } }) =>
            state.settings.botChatBgColor
    );

    const botLanguage = useSelector(
        (state: { settings: { botLanguage: string } }) =>
            state.settings.botLanguage
    );

    const isStartBot = useSelector(
        (state: { session: { isStartBot: boolean } }) =>
            state.session.isStartBot
    );

    const respondedToBot = useSelector(
        (state: { session: { respondedToBot: boolean } }) =>
            state.session.respondedToBot
    );

    const respondedToAgent = useSelector(
        (state: { session: { respondedToAgent: boolean } }) =>
            state.session.respondedToAgent
    );

    const chatCountReason = useSelector(
        (state: { session: { chatCountReason: string } }) =>
            state.session.chatCountReason
    );

    const intentInfo = useSelector(
        (state: { settings: { intentInfo: object } }) =>
            state.settings.intentInfo
    );

    const isIntentSuggestionModal = useSelector(
        (state: { status: { isIntentSuggestionModal: Boolean } }) =>
            state.status.isIntentSuggestionModal
    );

    const intentChoice = useSelector(
        (state: { session: { intentChoice: string } }) =>
            state.session.intentChoice
    );

    const apiPath = useSelector(
        (state: { session: { apiPath: string } }) =>
            state.session.apiPath
    );

    const processor = useSelector(
        (state: { settings: { processor: number } }) =>
            state.settings.processor
    );

    const isBotTyping = useSelector(
        (state: { status: { isBotTyping: Boolean } }) =>
            state.status.isBotTyping
    );

    const customValues = useSelector(
        (state: { settings: { customValues: string } }) => state.settings.customValues
    );

    const botName = useSelector(
        (state: { settings: {botName: string}}) =>
            state.settings.botName
    )

    const brandCode = useSelector(
        (state: { settings: { brandCode: string } }) => state.settings.brandCode
    )

    const marketCode = useSelector(
        (state: { settings: { marketCode: string } }) => state.settings.marketCode
    )

    const conversationId = useSelector(
        (state: { session: { conversationId: string } }) =>
            state.session.conversationId
    );

    const accessToken = useSelector(
        (state: { session: { accessToken: string } }) =>
            state.session.accessToken
    );

    const isAuthenticated = useSelector(
        (state: { session: { isAuthenticated: any } }) =>
            state.session.isAuthenticated
    );

    const memberCode = useSelector(
        (state: { session: { memberCode: string } }) => state.session.memberCode
    );

    const queueStatus = useSelector(
        (state: { status: { queueStatus: String } }) => state.status.queueStatus
    );

    const disableSurvey = useSelector(
        (state: { status: { disableSurvey: boolean } }) => state.status.disableSurvey
    );

    const matchStartDate = useSelector(
        (state: { session: { matchStartDate: string } }) => state.session.matchStartDate
    );

    const nps = useSelector(
        (state: { session: { nps: string } }) => state.session.nps
    );

    const vip = useSelector(
        (state: { session: { isVip: any } }) => state.session.isVip
    );

    const betslipId = useSelector(
        (state: { session: { betslipId: string } }) => state.session.betslipId
    );

    const referrerSite = useSelector(
        (state: { session: { referrerSite: string } }) => state.session.referrerSite
    );

    const queue = useSelector(
        (state: { session: { queue: string } }) => state.session.queue
    );

    const enQueue = useSelector(
        (state: { session: { enQueue: boolean } }) => state.session.enQueue
    );

    const caseNumber = useSelector(
        (state: { session: { caseNumber: string } }) => state.session.caseNumber
    );

    const dataCustomValues = customValues ? JSON.parse(customValues) : {};
    const surveyCustomLink = dataCustomValues.hasOwnProperty('survey_link') ? dataCustomValues.survey_link : ""
    const live_agent_flag = dataCustomValues.hasOwnProperty('live_agent_mode') ? dataCustomValues.live_agent_mode : '0'
    const uploadTarget = dataCustomValues.hasOwnProperty('upload_target') ? dataCustomValues.upload_target : "";
    const upload_file_version = dataCustomValues.hasOwnProperty('upload_file_version') ? dataCustomValues.upload_file_version : "0";
    const isVipBot = String(dataCustomValues?.is_vip_bot ?? 'false').toLowerCase() === 'true';
    const acqQueueFlag = dataCustomValues.hasOwnProperty('acq_queue_flag') ? dataCustomValues.acq_queue_flag : "";
    const acqQueueDays = dataCustomValues.hasOwnProperty('acq_queue_days') ? dataCustomValues.acq_queue_days : "";
    const agentAuthEnabled = String(dataCustomValues?.agent_auth_enabled ?? 'true').toLowerCase() === 'true';
    const isAffBot = String(dataCustomValues?.is_aff_bot ?? 'false').toLowerCase() === 'true';

    const endChatSettings = dataCustomValues.end_chat_settings ? JSON.parse(dataCustomValues.end_chat_settings) : {};
    const endChatPrompt = endChatSettings.end_chat_prompt ? endChatSettings.end_chat_prompt : null;
    const endChatYesButton = endChatSettings.yes_btn ? endChatSettings.yes_btn : null;
    const endChatNoButton = endChatSettings.no_btn ? endChatSettings.no_btn : null;

    const file_upload = dataCustomValues.hasOwnProperty('file_upload') ? JSON.parse(dataCustomValues.file_upload) : {};
    
    const default_max_files = 1;
    const max_files_property = `default_max_files`;
    const max_file_number = file_upload.hasOwnProperty(max_files_property) && file_upload[max_files_property] != null ? file_upload[max_files_property] : default_max_files;

    const isVipChatRatingDisabled =
        (isVipBot && chatMode === "bot") ||
        (isVipBot &&
            chatMode === "agent" &&
            (queueStatus === "queueingDialog" || queueStatus === "queueLoading"));

    const isAgentQueueing =
        queueStatus === 'queueingDialog' || queueStatus === 'queueLoading';

    const isLegacyAgentUpload =
        chatMode === 'agent' &&
        live_agent_flag !== '1' &&
        !(isVipBot && isAgentQueueing);

    const isMiawAgentUpload =
        chatMode === 'agent' &&
        live_agent_flag === '1' &&
        !isAgentQueueing;

    const openIntentSuggestionModal = () => {
        if (!isIntentSuggestionModal) {
            dispatch(
                editStatus({
                    name: 'isIntentSuggestionModal',
                    value: true,
                })
            );
        }
    };

    const closeIntentSuggestionModal = () => {
        if (isIntentSuggestionModal) {
            dispatch(
                editStatus({
                    name: 'isIntentSuggestionModal',
                    value: false,
                })
            );
        }
        if (intentChoice != '') {
            dispatch(
                editSession({
                    name: 'intentChoice',
                    value: '',
                })
            );
        }
    };

    useEffect(() => {
        console.log('chatcount respond', respondedToBot, respondedToAgent);
        cacheService.setCacheByField(
            sessionId,
            'respondedToBot',
            respondedToBot
        );
        cacheService.setCacheByField(
            sessionId,
            'respondedToAgent',
            respondedToAgent
        );
        cacheService.setCacheByField(sessionId, 'isStartBot', isStartBot);
    }, [respondedToBot, respondedToAgent]);

    let iconPath = require('../assets/send (2).png');

    const realign = () => {
        // setTimeout(() => {
        //     window.scrollTo(0, 0);
        //     document.body.scrollTop = 0;
        // }, 500);
    };

    const closeDialog = (type: string) => {
        dispatch(removeDialog(type));
    };

    const addUserMessage = async (overrideMessage?: string) => {
       if (sendingRef.current) {
           return;
       }
       sendingRef.current = true;
       try {
       try {
           const ended = await cacheService.checkCache(sessionId, tabId);
           if (ended) {
               return;
           }
       } catch (e) {
           error(Footer.name, 'checkCache before addChat failed', e);
       }

       // Store values before clearing UI
       const imagesToProcess = [...selectedImages];
       const messageToProcess = overrideMessage ?? messageToSend;
       const filteredMessageToProcess = overrideMessage ?? filteredMessage;
       const originalInputMessage = overrideMessage ?? inputMessage;

       // Clear UI immediately
       setInputMessage('');
       setFilteredMessage('');
       setSelectedImages([]);
       closeIntentSuggestionModal();
       
       let cacheInfo = {
           sessionId: botId.toString() + sessionId,
           cacheUrl: apiPath,
           botName: botName
       }
       const state = store.getState();
       const isAuthenticated = state.session.isAuthenticated;
       // Process images if any exist
       if (imagesToProcess.length > 0) {
           const filePromises = imagesToProcess.map((img) => {
               return new Promise((resolve, reject) => {
                   const reader = new FileReader();
                   reader.onload = () => {
                       const result = reader.result as string;
                       resolve({
                           filename: img.file.name,
                           mimetype: img.file.type,
                           content: result.split(",")[1], // remove base64 prefix
                       });
                   };
                   reader.onerror = reject;
                   reader.readAsDataURL(img.file);
               });
           });
       
           await Promise.all(filePromises).then(async (files_data) => {
               if (isMiawAgentUpload) {
                   const fileData = files_data[0] as {
                       filename: string;
                       mimetype: string;
                       content: string;
                   };

                   const data = {
                        message: filteredMessageToProcess,
                        type: 'message',
                        filename: fileData.filename,
                        file: `data:${fileData.mimetype};base64,${fileData.content}`,
                        fileFlag: 'MIAW',
                        encoding: 'UTF-8',
                        chatId: chatId,
                        conversationId: conversationId,
                        accessToken: accessToken,
                        liveAgentFlag: live_agent_flag,
                        username: username,
                        isAuthenticated: isAuthenticated,
                        isVipBot: isVipBot,
                        memberCode: memberCode,
                        brandInfo: {
                            brand: brandCode,
                            market: marketCode
                        },
                        cacheInfo: cacheInfo,
                        isAffBot: isAffBot
                   };

                   if (
                       !respondedToAgent &&
                       chatCountReason != 'respondedToAgent'
                   ) {
                       dispatch(
                           editSessions({
                               respondedToAgent: true,
                               chatCountReason: 'respondedToAgent',
                           })
                       );
                   }

                   await socket.sendChasitorMessageEvent(data);
                   dispatch(
                    editStatus({
                        name: 'isLoadingModal',
                        value: true,
                    })
                );
               } else {
                let data = {
                    message: filteredMessageToProcess,
                    original_message: originalInputMessage,
                    type: 'message',
                    username: username,
                    chatId: chatId,
                    customer_lang_culture:
                        botLanguage.toLowerCase() === 'chinese'
                            ? 'zh-cn'
                            : botLanguage.toLowerCase() === 'thai'
                            ? 'th-th'
                            : botLanguage.toLowerCase() === 'vietnamese'
                            ? 'vi-vn'
                            : botLanguage.toLowerCase() === 'vietnam'
                            ? 'vi-vn'
                            : botLanguage.toLowerCase() === 'english'
                            ? 'en'
                            : botLanguage.toLowerCase(),
                    operating_system: getOS(navigator),
                    screen_resolution: window.screen.width + '*' + window.screen.height,
                    platform: 'mario',
                    group_name: '',
                    processor: processor,
                    cacheInfo: cacheInfo,
                    brandInfo: {
                        brand: brandCode,
                        market: marketCode
                    },
                    imageLinks: '',
                    files_data: files_data, 
                    upload_target: uploadTarget,
                    transaction_id: "",
                    upload_receipt_type: "default",
                    memberCode : memberCode,
                    isAuthenticated: isAuthenticated,
                    isVipBot: isVipBot
                };
        
                if (!respondedToBot && chatCountReason != 'respondedToBot') {
                    if (!isStartBot) {
                        dispatch(editSession({ name: 'isStartBot', value: true }));
                    }
                    dispatch(
                        editSessions({
                            respondedToBot: true,
                            chatCountReason: 'respondedToBot',
                        })
                    );
                }
        
                await dispatch(editStatus({ name: 'isBotTyping', value: true }));
                dispatch(editSession({ name: 'waitingAnswerReply', value: true }));
                cacheService.setCacheByField(sessionId, 'waitingAnswerReply', true);
                socket.sendFileMessageEvent(data);
                
                // Open loading for upload file
                dispatch(
                    editStatus({
                        name: 'isLoadingModal',
                        value: true,
                    })
                );
               }              
           });
       }

       // Process Text - only if no images were uploaded OR if image upload was successful
       else if (
           (filteredMessageToProcess != '' &&
           filteredMessageToProcess.trim() != '' &&
           messageToProcess.trim() != '')
        ) {
            closeDialog('timeoutWarning');
            const content = {
                owner: 'user',
                name: username,
                type: 'text',
                message: {
                    content: messageToProcess,
                },
                displayTime: format(new Date(), 'hh:mmaa'),
                createdBy: new Date().getTime(),
            } as ChatInterface;
            cacheService.pushCache(
                sessionId + '_chats',
                JSON.stringify(content)
                
            );
            dispatch(addChat(content));
            if (chatMode === 'bot') {
                if(isVipBot){
                    cacheService.setCacheByField(sessionId, 'chatMode', 'agent');
                    dispatch(editSession({ name: 'chatMode', value: 'agent' }));
                    cacheService.setCacheByField(sessionId, 'queueStatus', 'queueLoading');
                    dispatch(editStatus({ name: 'queueStatus', value: 'queueLoading' }));
                    socket.sendConnectAgentEvent({
                        chatId: chatId,
                        isStartAgent: false,
                        isStartBot: true,
                        isVip: vip[0],
                        triggerTime: new Date().getTime().toString(),
                        language: 'chinese',
                        screen_resolution:
                            window.screen.width + 'x' + window.screen.height,
                        userAgent: navigator.userAgent,
                        nps: nps,
                        matchStartDateTime: matchStartDate,
                        betslipId: betslipId,
                        type: 'connect',
                        username: username,
                        queue: queue,
                        sfQueueId: '',
                        sfReferrer: referrerSite? referrerSite : document.referrer,
                        connect_flag: "Gloqo Connect",
                        cacheId: botId.toString() + sessionId,
                        cacheUrl : apiPath,
                        browser: getBrowser(),
                        sfPlatform: getPlatform(),
                        acqQueueFlag: acqQueueFlag,
                        enQueue: enQueue,
                        acqQueueDays: acqQueueDays,
                        caseNumber: caseNumber,
                        liveAgentFlag: JSON.parse(customValues).hasOwnProperty('live_agent_mode') ? JSON.parse(customValues).live_agent_mode : '0',
                        isAuthenticated: isAuthenticated,
                        memberCode: memberCode,
                        brandCode: brandCode,
                        marketCode: marketCode,
                        agentAuthEnabled: agentAuthEnabled,
                        isVipBot: isVipBot,
                        botName: botName,
                    });
                    socket.sendUploadChatEvent({
                        chatId: chatId,
                        speaker: 'Client',
                        speakerName: username,
                        datetime: new Date().toJSON(),
                        message: filteredMessageToProcess,
                        messageSource: "member"
                    })
                } else {
                    let cacheInfo = {
                        sessionId: botId.toString() + sessionId,
                        cacheUrl: apiPath,
                        botName: botName
                    }
                    let data = {
                        message: filteredMessageToProcess,
                        original_message: originalInputMessage,
                        type: 'message',
                        username: username,
                        chatId: chatId,
                        customer_lang_culture:
                            botLanguage.toLowerCase() === 'chinese'
                                ? 'zh-cn'
                                : botLanguage.toLowerCase() === 'thai'
                                ? 'th-th'
                                : botLanguage.toLowerCase() === 'vietnamese'
                                ? 'vi-vn'
                                : botLanguage.toLowerCase() === 'vietnam'
                                ? 'vi-vn'
                                : botLanguage.toLowerCase() === 'english'
                                ? 'en'
                                : botLanguage.toLowerCase(),
                        operating_system: getOS(navigator),
                        screen_resolution:
                            window.screen.width + '*' + window.screen.height,
                        platform: 'mario',
                        group_name: '',
                        processor: processor,
                        cacheInfo: cacheInfo,
                        brandInfo : {
                            brand: brandCode,
                            market: marketCode
                        },
                        memberCode : memberCode,
                        isAuthenticated: isAuthenticated,
                        isVipBot: isVipBot,
                    };
                    if (!respondedToBot && chatCountReason != 'respondedToBot') {
                        if (!isStartBot) {
                            dispatch(
                                editSession({
                                    name: 'isStartBot',
                                    value: true,
                                })
                            );
                        };
                        dispatch(
                            editSessions({
                                respondedToBot: true,
                                chatCountReason: 'respondedToBot',
                            })
                        );
                    }
                    await dispatch(editStatus({ name: 'isBotTyping', value: true }));
                    dispatch(editSession({ name: 'waitingAnswerReply', value: true }));
                    cacheService.setCacheByField(sessionId, 'waitingAnswerReply', true)
                    socket.sendMessageEvent(data);

                }
            } else if (chatMode === 'agent') {
                if (queueStatus === 'queueingDialog' || queueStatus === 'queueLoading'){
                    socket.sendUploadChatEvent({
                        chatId: chatId,
                        speaker: 'Client',
                        speakerName: username,
                        datetime: new Date().toJSON(),
                        message: filteredMessageToProcess,
                        messageSource: "member"
                    })
                } else {
                    let data = {
                        affinityToken: laAffinityToken,
                        key: laSessionKey,
                        message: filteredMessageToProcess,
                        type: 'message',
                        username: username,
                        chatId: chatId,
                        liveAgentFlag: live_agent_flag,
                        conversationId: conversationId,
                        accessToken: accessToken,
                        isAuthenticated: isAuthenticated,
                        brandInfo: {
                            brand: brandCode,
                            market: marketCode
                        },
                        memberCode: memberCode,
                        isVipBot: isVipBot,
                        isAffBot: isAffBot
                    };
    
                    if (
                        !respondedToAgent &&
                        chatCountReason != 'respondedToAgent'
                    ) {
                        dispatch(
                            editSessions({
                                respondedToAgent: true,
                                chatCountReason: 'respondedToAgent',
                            })
                        );
                    }
    
                    await socket.sendChasitorMessageEvent(data);
                }
            }
        }
       } finally {
           sendingRef.current = false;
       }
    };

    let isOnComposition: boolean = false;

    const handleComposition = (e: React.CompositionEvent<HTMLInputElement>) => {
        // console.log(e);
        if (e.type === 'compositionend') {
            // composition is end
            isOnComposition = false;
        } else {
            // in composition
            isOnComposition = true;
        }
    };

    // useEffect(() => {
    //     if (chatMode === 'agent') {
    //         if (isTyping && inputMessage.trim().length > 0) {
    //             clearTimeout(typingTimer);
    //             setTypingTimer(
    //                 setTimeout(() => {
    //                     socket.sendChasitorTypingEvent({
    //                         affinityToken: laAffinityToken,
    //                         key: laSessionKey,
    //                         text: messageToSend,
    //                         username: username,
    //                         chatId: chatId,
    //                     });
    //                 }, 2000)
    //             );
    //         } else {
    //             clearTimeout(typingTimer);
    //             socket.sendChasitorNotTypingEvent({
    //                 affinityToken: laAffinityToken,
    //                 key: laSessionKey,
    //                 text: '',
    //                 username: username,
    //                 chatId: chatId,
    //             });
    //         }
    //     }
    // }, [inputMessage, chatMode]);

    useEffect(() => {
        if (chatMode == 'bot') {
            if (isTyping && inputMessage.trim().length >= 2) {
                clearTimeout(typingTimer);
                setTypingTimer(
                    setTimeout(() => {
                        getIntentList();
                    }, 500)
                )
            }
            else {
                clearTimeout(typingTimer);
            }
        }
    }, [inputMessage, chatMode]);

    const getIntentList = () => {
        const botAccountId = `${acctId}${botId}`;
        const search = inputMessage;
        var intentList:any = [];
        return new Promise(async (resolve, reject) => {
            try {
                const res:any = await post(`${apiPath}/getIntentInfo`, {
                    data: {
                        botAccountId,
                        search,
                    },
                });
                resolve(res);
                intentList = res;
                if (intentList && processor == 0) {
                    dispatch(
                        editSession({
                            name: 'intentSuggestion',
                            value: intentList,
                        })
                    );
                    openIntentSuggestionModal();
                }
            } catch (e) {
                error(
                    'Exception when getting intent info from cache:',
                    e
                );
                reject(e);
            }
        });
    };

    const handleInputChange = async (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        let text = e.target.value;
        setInputMessage(text);
        if (text.length > 0) {
            setIsTyping(true);
        } else {
            setIsTyping(false);
        }
        const [filteredText, filteredTextAndRules]: any = await filter(
            regExp,
            filters,
            text.normalize("NFC"),
            t('matchedFilterMessage')
        );

        const isString = (value: unknown): value is string => {
            return !!value && typeof value === 'string';
        };

        setFilteredMessage(
            isString(filteredTextAndRules) ? filteredTextAndRules : ''
        );

        setInputMessage(text);

        setMessageToSend(filteredText);


        if (text == '') {
            closeIntentSuggestionModal();
        }
    };

    useEffect(() => {
        if (!intentChoice) {
            return;
        }
        const choice = intentChoice;
        closeIntentSuggestionModal();
        addUserMessage(choice);
    }, [intentChoice]);

    const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
        if ((isValidInputMessage)) {
            addUserMessage();
        } 
    };

    const handleKeyDown = async (
        event: React.KeyboardEvent<HTMLInputElement>
    ) => {
        if (event.key === 'Enter') {
            if (event.nativeEvent.isComposing || event.keyCode === 229) {
                return;
            }
            event.preventDefault();
            if (inputMessage === '__warn') {
                dispatch(
                    addDialog({
                        task: 'timeoutWarning',
                        type: 'message',
                        message: 'Timeout',
                        actionMessage: 'Reconnect',
                    } as DialogInterface)
                );
            } else if (inputMessage === '__disconnect') {
                dispatch(
                    addDialog({
                        task: 'disconnected',
                        type: 'action',
                        message: 'You are disconnected',
                        actionMessage: 'Reconnect',
                    } as DialogInterface)
                );
            } else if (inputMessage === '__end') {
                dispatch(
                    addDialog({
                        task: 'ended',
                        type: 'action',
                        message: 'You are ended',
                        actionMessage: 'Reconnect',
                    } as DialogInterface)
                );
            } else if (inputMessage === '__timeout') {
                dispatch(
                    addDialog({
                        task: 'timeout',
                        type: 'action',
                        message: 'You are timeout',
                        actionMessage: 'Reconnect',
                    } as DialogInterface)
                );
            } else if ((isValidInputMessage && inputMessage) || selectedImages.length > 0) {
                addUserMessage();
            } else {

            }
        }
    };

    const handleRatingClick = () => {
        const isRatingDone = chatRatingDone === true;
        const isBotMode = chatMode === 'bot';
        const isMarioSurvey = surveyCustomLink === 'mario';
        
        if (
            ((isRatingDone && (isBotMode || isMarioSurvey)) || (isBotMode && isVipBot)) || disableSurvey
                || isAffBot
        ){            
            Swal.fire({
                title: '',
                text: endChatPrompt? endChatPrompt : t('ratingSubmitted'),
                icon: 'success',
                confirmButtonText: endChatYesButton? endChatYesButton : t('ratingEndChat'),
                confirmButtonColor: botButtonColor
                    ? botButtonColor.slice(0, 7)
                    : '',
                showCancelButton: true,
                cancelButtonText: endChatNoButton? endChatNoButton : t('ratingContinueChat'),
            }).then((result) => {
                if (result.isConfirmed) {
                    dispatch(addDialog({ task: 'leaved', type: 'action' }));
                    cacheService.endSession(sessionId);
                }
            });
        } else {

            if(chatMode === 'agent') {

                // Feedback form message is different for T1M1 bots
                let IsT1M1 = acctId.toString() + botId.toString();
                let T1M1ID = ["422", "430"];

                dispatch(
                    editStatus({
                        name: 'isChatRatingModal',
                        value: true,
                    })
                );
                

                // Swal.fire({
                //     title: '',
                //     text: T1M1ID.includes(IsT1M1) ? t('feedbackFormMessageAgentT1M1'): t('feedbackFormMessageAgent'),
                //     icon: 'info',
                //     confirmButtonText: t('feedbackFormAgent'),
                //     confirmButtonColor: botButtonColor
                //         ? botButtonColor.slice(0, 7)
                //         : '',
                //     showCancelButton: true,
                //     cancelButtonText: t('ratingContinueChat'),
                //     showDenyButton: true,
                //     denyButtonText: t('ratingEndChat'),
                // }).then((result) => {
                //     if (result.isConfirmed) {
        
                //         dispatch(
                //             editStatus({
                //                 name: 'isChatRatingModal',
                //                 value: true,
                //             })
                //         );
        
                //     } else if (result.isDenied) {
        
                //         dispatch(addDialog({ task: 'leaved', type: 'action' }));
                //         cacheService.endSession(sessionId);
        
                //       }
                // });


            } else {
                dispatch(
                    editStatus({
                        name: 'isChatRatingModal',
                        value: true,
                    })
                );
            }


            // dispatch(
            //     editStatus({
            //         name: 'isChatRatingModal',
            //         value: true,
            //     })
            // );
        }

        // dispatch(
        //     editStatus({
        //         name: 'isChatRatingModal',
        //         value: true,
        //     })
        // );
    };

    const handleUploadAgent = async (event:any) => {

        const originalFile = event.target.files[0];
        let file = String(originalFile?.type ?? '').startsWith('image/')
            ? await compressImageFile(originalFile)
            : originalFile;
        let filename = file['name'];
        let filesize = file['size'];
        let filetype = file["type"].split("/");

        const state = store.getState();
        const isAuthenticated = state.session.isAuthenticated;

        console.log("FILE", event.target.files[0]);
        console.log("UPLOADED FILE",filename,filesize, filetype);

        const validFileTypes = ["jpg","png","jpeg" ,"gif","pdf"];

        let regexFile = /(?:\.([^.]+))?$/;

        let fileExtension = filename.match(regexFile);
        fileExtension = fileExtension[1].toLowerCase();

        console.log("FILE EXTENTION", fileExtension);

        let fileSizeLimit = 5 * 1048576;

        if (filesize > fileSizeLimit || !validFileTypes.includes(fileExtension)) {

            const wrongFileSizeMessage = {
                owner: 'system',
                name: 'Mario',
                type: 'text',
                message: {
                    content:
                        t("fileUploadInvalid"),
                },
                displayTime: format(new Date(), 'hh:mmaa'),
                createdBy: new Date().getTime(),
            } as ChatInterface;
            dispatch(addChat(wrongFileSizeMessage));
            
        } 
        else {
        
            let reader = new FileReader();
            reader.readAsDataURL(file);

            if (live_agent_flag == '1') {
                reader.onload = function () {
                    let data = {
                        "filename": filename,
                        "file": reader.result,
                        "fileFlag" : "MIAW",
                        "encoding": 'UTF-8',
                        "chatId": chatId,
                        "conversationId": conversationId,
                        "accessToken": accessToken,
                        "liveAgentFlag": live_agent_flag,
                        "username": username,
                        "isAuthenticated": isAuthenticated,
                        "isVipBot": isVipBot
                    }
                    dispatch(removeDialog('uploadFile'));
                    console.log("DATE HERE", data);
                    socket.sendChasitorMessageEvent(data);
                }
            }
            else {
                reader.onload = function () {
                    let data = {
                        "filename": filename,
                        "file": reader.result,
                        "url": "",
                        "orgId":  "",
                        "chatKey":  "",
                        "fileToken":  "",
                        "fileFlag" : "MARIO",
                        "encoding": 'UTF-8',
                        "chatId": chatId,
                        "isAuthenticated": isAuthenticated,
                        "isVipBot": isVipBot
                    }
                    dispatch(removeDialog('uploadFile'));
                    console.log("DATE HERE", data);
                    socket.sendUploadFileEvent(data);
                }
            }
        }
    }

    const handleUploadBot = async(event: React.ChangeEvent<HTMLInputElement>) => {
        // Kept out of the pooled synthetic event so it stays usable after awaits
        const fileInput = event.target;
        const files = Array.from(fileInput.files || []);
        if (!files.length) return;
    
        const getExtension = (filename: string) =>
            filename.split(".").pop()?.toLowerCase() || "";
    
        const validFileTypes = ["image/jpeg", "image/png", "image/gif"];
        const validExtensions = ["jpeg", "jpg", "png", "gif"];
        const maxFileSize = 4 * 1024 * 1024;
        const maxOriginalFileSize = 4 * 1024 * 1024;
    
        // Max file number check
        if (files.length + selectedImages.length > max_file_number) {
            showAlert(t("uploadFileModal.alertMaxFiles", {max_file_number}));
            fileInput.value = "";
            return;
        }
    
        // Large file check, compression runs afterwards so the limit here is the decode limit
        const largeFiles = files.filter(file => file.size >= maxOriginalFileSize);
        if (largeFiles.length > 0) {
            showAlert(t("uploadFileModal.alertFileSize"));
            fileInput.value = "";
            return;
        }
    
        // Invalid type check
        const invalidFiles = files.filter(file => {
            const ext = getExtension(file.name);
            return (
                !validFileTypes.includes(file.type) ||
                !validExtensions.includes(ext)
            );
        });
        
        if (invalidFiles.length > 0) {
            showAlert(t("uploadFileModal.defaultAlertSupportType"));
            fileInput.value = "";
            return;
        }
    
        // Valid files
        const validFiles = files.filter(file => {
            const ext = getExtension(file.name);
            return (
                validFileTypes.includes(file.type) &&
                file.size < maxOriginalFileSize &&
                ext !== "jfif" &&
                ext !== "pjp"
            );
        });

        //Filter out animated GIFs
        const animatedGifs: File[] = [];
        for (const file of files) {
            if (file.type === "image/gif" && await isAnimatedGif(file)) {
                animatedGifs.push(file);
            }
        }
        if (animatedGifs.length > 0) {
            showAlert(t("uploadFileModal.alertAnimatedGifNotAllowed"));
            fileInput.value = "";
            return;
        }
    
        //  Duplicate check
        const duplicates = validFiles.filter(file =>
            selectedImages.some(selected => selected.id === generateFileId(file))
        );
        if (duplicates.length > 0) {
            showAlert(t("uploadFileModal.alertSameFile"));
            fileInput.value = "";
            return;
        }
    
        //  Compress valid images before they are queued for upload
        const compressedImages = await Promise.all(
            validFiles
                .filter(file => file.type.startsWith("image/"))
                .map(async file => ({
                    id: generateFileId(file),
                    file: await compressImageFile(file),
                }))
        );

        // Size check on what is actually uploaded
        if (compressedImages.some(image => image.file.size >= maxFileSize)) {
            showAlert(t("uploadFileModal.alertFileSize"));
            fileInput.value = "";
            return;
        }

        //  Process valid images
        const newImages = await Promise.all(
            compressedImages.map(async ({ id, file }): Promise<SelectedImage> => ({
                id,
                file,
                preview: await readFileAsDataUrl(file),
                name: file.name,
            }))
        );
        setSelectedImages(prev => [...prev, ...newImages]);
        // Reset input so user can select same file again
        fileInput.value = "";
    };

    const readFileAsDataUrl = (file: File): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    
    const generateFileId = (file: File) => `${file.name}-${file.size}-${file.lastModified}`;

    async function isAnimatedGif(file: File): Promise<boolean> {
        const arrayBuffer = await file.arrayBuffer();
        const gif = parseGIF(arrayBuffer);
        const frames = decompressFrames(gif, true);

        if (frames.length <= 1) {
            return false; // definitely static
        }

        // check if frames are actually different
        for (let i = 1; i < frames.length; i++) {
            if (frames[i].patch.toString() !== frames[0].patch.toString()) {
                return true; // animated (different frames)
            }
        }
        return false; // all frames identical → static
    }

    const showAlert = (message: string) => {
        dispatch(editStatus({name: "alertMessage", value: message}))
        dispatch(
            editStatus({
                name: 'isAlertModal',
                value: true,
            })
        )
    };

    const removeImage = (imageId: string) => {
        setSelectedImages(prev => prev.filter(img => img.id !== imageId));
    };

    useEffect(() => {
        if (checkInputMessage(inputMessage) || selectedImages.length > 0) {
            setIsValidInputMessage(true);

        } else {
            setIsValidInputMessage(false);
        }
    }, [inputMessage, selectedImages]);

    useEffect(() => {
        // Automatically focus the input field when the bot finishes typing
        if (!isBotTyping) {
          inputRef.current?.focus();
        }
    }, [isBotTyping]);

    useEffect(() => {
        if (selectedImages.length > 0) {
            inputRef.current?.focus();
        }
    }, [selectedImages]);

    return (
        <div
            className="pb-[20px] px-2 small:pb-0 small:px-0 small:rounded-b-xl"
            style={{
                backgroundColor: botChatBgColor
                    ? botChatBgColor.slice(0, 7)
                    : '',
            }}
        >
            <div
                style={{
                    backgroundColor: botColor ? botColor.slice(0, 7) : '',
                }}
                className={classNames(
                    'h-[48px] sm:h-[52px] bg-slate-300 rounded-t-xl rounded-b-xl small:rounded-t-none flex px-2 items-center border-t-2 border-slate-200 relative shadow-md',
                    {
                        'pointer-events-none': !isChatAlive,
                        hidden: !isChatAlive,
                    }
                )}
            >
                <p className="text-black text-2xs bg-gray-300 absolute top-0 right-0">
                    {/* {props.debug} */}
                </p>
                {!isChatRatingSubmitted && (
                    <div
                        onClick={isVipChatRatingDisabled ? undefined : handleRatingClick}
                        className={classNames(
                            "h-full px-1 flex justify-center items-center z-10",
                            isVipChatRatingDisabled ? "opacity-50 pointer-events-none" : "hover:cursor-pointer"
                        )}
                    >
                        <div
                            // style={{ backgroundColor: `${botCloseButtonColor}` }}
                            className={classNames(
                                'w-[32px] h-[32px] rounded-full bg-yellow-400 flex justify-center items-center'
                            )}
                        >
                            <FontAwesomeIcon
                                icon={faStar}
                                className="text-white font-medium text-[16px] small:text-base inline-block cursor-pointer"
                            />
                            {/* {botCloseButtonText && (
                    <div className="text-white text-lg whitespace-nowrap hover:cursor-pointer">
                        {botCloseButtonText}
                    </div>
                )}
                {!botCloseButtonText && (
                    <FontAwesomeIcon
                        icon={faCircleXmark}
                        className={classNames('text-xl flex-none z-10', {
                            'text-red-600/75': !botCloseButtonColor,
                            'text-white': botCloseButtonColor,
                        })}
                    />
                )} */}
                        </div>
                    </div>
                )}
                
                {/* Single paperclip icon for both agent and bot modes */}
                {(((processor === 2 || processor === 3) && upload_file_version === "1") || (chatMode === 'agent')) && (
                    <div
                        className={`h-full text-[24px] px-1 flex justify-center items-center z-10 hover:cursor-pointer
                            ${
                                (
                                    isBotTyping &&
                                    (processor === 2 || processor === 3)
                                ) ||
                                (
                                    !isVipBot &&
                                    (queueStatus === 'queueingDialog' || queueStatus === 'queueLoading')
                                )
                                    ? 'opacity-50 pointer-events-none'
                                    : ''
                            }`}
                    > 
                        <label htmlFor="file-upload" className='cursor-pointer text-black'>
                            <FontAwesomeIcon
                                icon={faPaperclip}
                                className="text-black inline-block cursor-pointer"
                            />
                        </label>

                        {/* Hidden input that changes based on chatMode */}
                        <input
                            type="file"
                            className='hidden'
                            id="file-upload"
                            onChange={
                                isLegacyAgentUpload
                                    ? handleUploadAgent
                                    : handleUploadBot
                            }
                            multiple={!isLegacyAgentUpload}
                            disabled={
                                (
                                    isBotTyping &&
                                    (processor === 2 || processor === 3)
                                ) ||
                                (
                                    !isVipBot &&
                                    (queueStatus === 'queueingDialog' || queueStatus === 'queueLoading')
                                )
                            }
                        />
                    </div>
                )}

                {/* Display selected images above the typing bar */}
                {selectedImages.length > 0 && (
                    <div 
                        className="absolute bottom-[80%] left-0 right-0 rounded-t-lg p-2 max-h-32 overflow-y-auto"
                        style={{
                            backgroundColor: botColor ? botColor.slice(0, 7) : '',
                            scrollbarWidth: 'none', /* Firefox */
                            msOverflowStyle: 'none', /* Internet Explorer 10+ */
                        }}
                    >
                        <div className="flex flex-wrap pl-2 pt-2">
                            {selectedImages.map((image) => (
                                <div key={image.id} className="relative group">
                                    <img
                                        src={image.preview}
                                        alt={image.name}
                                        className="w-16 h-16 object-cover rounded border border-gray-300"
                                    />
                                    <button
                                        onClick={() => removeImage(image.id)}
                                        className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs opacity-0 group-hover:opacity-100 transition-opacity"
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                    </button>
                                    <div className="text-xs text-gray-600 mt-1 truncate w-16 text-center">
                                        {image.name.length > 12 ? image.name.substring(0, 12) + '...' : image.name}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}                

                <input
                    style={{
                        backgroundColor: botColor ? botColor.slice(0, 7) : '',
                    }}
                    type="search"
                    className={classNames("w-full grow h-full px-2 bg-slate-300 text-base focus:outline-none",
                        {
                            'border-2 border-red-300': !isValidInputMessage,
                        }
                    )}
                    onCompositionStart={handleComposition}
                    onCompositionUpdate={handleComposition}
                    onCompositionEnd={handleComposition}
                    onChange={handleInputChange}
                    onFocus={realign}
                    onClick={realign}
                    value={inputMessage}
                    onKeyDown={handleKeyDown}
                    placeholder={typingBarPlaceHolder}
                    autoComplete="off"
                    autoCorrect="off"
                    autoSave="off"
                    ref={inputRef}
                    maxLength={1000}
                    disabled={
                        (isBotTyping && (processor === 2 || processor === 3) && selectedImages.length === 0) ||
                        (!isVipBot && (queueStatus === 'queueingDialog' || queueStatus === 'queueLoading'))
                    }                
                />
                {/* <div className="w-10pc"></div> */}

                    
                <div className="min-w-10pc w-10pc h-full flex justify-center">
                    <Button
                        type="button"
                        fns={
                            [
                                {
                                    type: 'js',
                                    func: handleClick,
                                },
                            ] as (JsFuntionInterface & ReduxFunctionInterface)[]
                        }
                        disabled={
                            (isBotTyping && (processor === 2 || processor === 3) && selectedImages.length === 0) ||
                            (!isVipBot && (queueStatus === 'queueingDialog' || queueStatus === 'queueLoading'))
                        } // Add this line to disable the button
                        className={(isBotTyping && (processor === 2 || processor === 3)) ||
                            (!isVipBot && (queueStatus === 'queueingDialog' || queueStatus === 'queueLoading')) ? 'opacity-50 pointer-events-none' : ''}
                    >
                        <img
                            className="w-6 h-6 small:w-6 small:h-6 large:w-8 large:h-8 hover:cursor-pointer"
                            src={require('../assets/send (2).png')}
                        ></img>
                    </Button>
                </div>
            </div>
        </div>
    );
};

Footer.propTypes = {};

export default Footer;
